module.exports = __webpack_public_path__ + "../static/img/gizlogo-unternehmen-de-rgb-300.9f7d29e7.jpg";